import * as React from "react";
import { makeStyles } from "@fluentui/react-components";
import { useState, useEffect } from "react";
import SearchCriteria from "./index/SearchCriteria";
import RecentList from "./index/RecentList";
import IndexingForm from "./index/IndexingForm";
import services from "../services/indexService";
import { taskPaneInitailValue, useTaskPane } from "../provider/TaskPaneProvider";
import useToast from "../hooks/useToast";
import { jwtDecode } from "jwt-decode";
import {SetAxiosDefauls} from "../services/authInterceptor";
import Loader from "./index/loader";
import { appInsights } from '../../telemetry/telemetryService';

const useStyles = makeStyles({
  root: {
    minHeight: "100vh",
  },
});

const MainContent = (props) => {
  SetAxiosDefauls();
  const {
    setProfileDetails,
    setLocationData,
    taskPaneState,
    setTaskPaneState,
    profileDetails,
    setSelectedGridItem,
    setPoliciesDetailsForInsured,
    selectedItemDetailFromGrid,
    setCheckList,
    getLocationSpecificInfo,
    loading,
    setLoading,
    checkList,
    selectedGridItem,
    setDocumentType,
    setDocumentClass
  } = useTaskPane();
  const { Toaster, notify, dismissAllToasts } = useToast();
  const [username, setUsername] = useState(null);
  const accessToken = localStorage.getItem('access-token');
  const authToken = localStorage.getItem('auth-token');
  const getData = async () => {
    try {
        notify("progress");
        if (username != null) {
            console.log("Username retrieved:");
        }
        const result = await services.getUserProfileInfo(username);
        notify("success", "Profile data fetch successful!");
        setProfileDetails(result);
        sessionStorage.setItem('userId', result[0]?.userID);
        setTaskPaneState((prev) => ({ ...prev, userId: result[0]?.userID, profileUserGroupId: result[0]?.primaryUserGroupID, userGroupId: result[0]?.primaryUserGroupID, userGroup: result[0]?.userID }));
        getLocationData(result);
    } catch (e) {
        notify("error", "Failed to fetch profile data");
        console.log(e);
    }
    };
    const getAuthToken = async (name) => {
    try {
      localStorage.removeItem("auth-token");
      // notify("progress");
      if (username != null) {
        console.log("Username retrieved:");
      }
      const result = await services.getAuthToken(name);
      console.log('result', result);
      localStorage.setItem("auth-token", result.access_token)
      setUsername(name);
    } catch (e) {
      // notify("error", "Failed to fetch profile data");
      console.log(e);
    }
  };

  const getLocationData = async (profileData) => {
    try {
        notify("progress");
        if (username != null) {
            console.log("Username retrieved:");
        }
        const result = await services.bindLocation(username);
        notify("success", "Location data fetch successful!");
        setLocationData(result);
        if(result?.length ===1) {
           setPoliciesDetailsForInsured([]);
          setSelectedGridItem([]);
          setCheckList([]);
          const value = result[0]?.compLocID;
          const compId = profileData.filter((pd) => pd.compLocID == value)[0]?.companyID;
          setTaskPaneState((prev) => ({ ...prev, comLocId: value, compLocId: value, compId, checklistItem: "" }));
          if(value && compId)
            await getLocationSpecificInfo(value, compId, profileData[0].userID);
          }
    } catch (e) {
        notify("error", "Failed to fetch location data");
        console.log(e);
    }
  };

    useEffect(() => {
        if (accessToken) {
            try {
                const decoded = jwtDecode(accessToken);
                const preferredName = 
                    decoded.preferred_username || decoded?.unique_name || decoded.userPrincipalName || decoded.name || null;
                if (preferredName != null) { 
                  console.log("Decoded username from token"); 
                  getAuthToken(preferredName);
                }
            } catch (err) {
                console.error("Failed to decode token:", err);
            }
        }
    }, [accessToken]);

  useEffect(() => {
    if (username && !!authToken) {
      getData();
    }
  }, [username, authToken]);

    const criteriaChange = (criteria) => criteria === "Insured" || criteria === "Policy #"|| criteria  === "Submission #"
        ? "Type Insured/Policy"
        : criteria === "Producer #" || criteria === "Producer Name"
          ? "Type Producer"
          : "Type claim"

  const updateState = async (key, value) => {
    dismissAllToasts();
    switch (key) {
     case "comLocId":
        setPoliciesDetailsForInsured([]);
        setSelectedGridItem([]);
        setCheckList([]);
        setDocumentType([]);
        setDocumentClass([]);
        const compId = profileDetails.filter((pd) => pd.compLocID == value)[0]?.companyID;
        if(value && compId) {
          setTaskPaneState((prev) => ({ ...prev, ...taskPaneInitailValue, [key]: value, compLocId: value, compId, searchText: "", userGroupId: prev?.profileUserGroupId, userGroup: prev?.userId }));
          await getLocationSpecificInfo(value, compId);
        } else {
          setTaskPaneState((prev) => ({ 
            ...prev, 
            ...taskPaneInitailValue, 
            [key]: value, 
            compLocId: value, 
            compId, 
            searchText: "", 
            userGroupId: prev?.profileUserGroupId, 
            userGroup: prev?.userId,
            insuredForRecentPoliciesResults: [],
            criteriaItems: [],
            criteria: "",
            insuredId: "",
          }));
        }
        break;
      case "criteria":
        let searchText = taskPaneState?.searchText;
        let checklistItem = taskPaneState?.checklistItem;
        if (criteriaChange(taskPaneState.criteria) !== criteriaChange(value)) {
          setPoliciesDetailsForInsured([]);
          setSelectedGridItem([]);
          searchText = "";
          checklistItem = "";
          if(criteriaChange(value) === "Type Insured/Policy" && taskPaneState.comLocId) {
            getLocationSpecificInfo(taskPaneState.compLocId, taskPaneState.compId, taskPaneState?.userId, value);
          }
        }
          setTaskPaneState((prev) => ({ ...prev, [key]: value, searchText, checklistItem}));
        break;
      case "insuredId":
        setTaskPaneState((prev) => ({ ...prev, [key]: value }));
        break;
      case "searchText":
        setTaskPaneState((prev) => ({ ...prev, [key]: value }));
        break;
      case "userGroupId":
        setTaskPaneState((prev) => ({ ...prev, [key]: value, userGroup: prev?.userId, taskQueue: "", taskType: "" }));
        break;
      case "docDescription":
      case "taskSubject":
        if(value?.length <= 60) {
        setTaskPaneState((prev) => ({ ...prev, [key]: value }));
      } else if(!!value && value?.length > 60) {
          setTaskPaneState((prev) => ({ ...prev, [key]: value.substring(0, 60) }));
        }
        break;
      case "docNotes":
        if(value?.length <= 255) {
          setTaskPaneState((prev) => ({ ...prev, [key]: value }));
        } else if(!!value && value?.length > 255) {
          setTaskPaneState((prev) => ({ ...prev, [key]: value.substring(0, 255) }));
        }
        break;
      case "checklistItem":
        const desctext = !!value? checkList.find(x => x.policyChecklistId == value)?.description || "" : "";
        const descTextTrim = (!!desctext && desctext?.length > 60) ? desctext.substring(0, 60) : desctext || "";
        setTaskPaneState((prev) => ({ 
          ...prev, 
          [key]: value, 
          docDescription: prev?.useChecklistItem? descTextTrim : prev?.docDescription || "",
          taskSubject: (prev?.sameAsDocDesc && prev?.useChecklistItem)? descTextTrim : prev?.taskSubject || ""
        }));
        break;
      case "useFileName":
        const fileName = localStorage.getItem("fileName");
        const fileNameText = value? (!!fileName && fileName?.length > 60) ? fileName.substring(0, 60) : fileName || "" : ""
        setTaskPaneState((prev) => ({ ...prev, 
          [key]: value, 
          useChecklistItem: value? false: prev?.useChecklistItem,
          sameAsDocDesc: (!value && !prev?.useChecklistItem)? false : prev?.sameAsDocDesc,
          taskSubject: prev?.sameAsDocDesc? fileNameText : prev?.taskSubject,
          docDescription: fileNameText
        }));
        break;
      case "useChecklistItem":
        let checkItemText = "";
        if(checkList?.length && !!taskPaneState?.checklistItem) {
          const checkItemData = checkList.find(x => x.policyChecklistId == taskPaneState?.checklistItem)
          checkItemText = checkItemData?.description || "";
        }
        const descText = value? (!!checkItemText && checkItemText?.length > 60) ? checkItemText.substring(0, 60) : checkItemText || "" : "";
          setTaskPaneState((prev) => ({ ...prev, 
            [key]: value, 
            useFileName: value? false: prev?.useFileName,
            sameAsDocDesc: (!value && !prev?.useFileName)? false : prev?.sameAsDocDesc,
            taskSubject: prev?.sameAsDocDesc? descText : prev?.taskSubject,
            docDescription: descText
          }));
        break;
      default:
        setTaskPaneState((prev) => ({ ...prev, [key]: value }));
        break;
    }
  };

  const handleIndex = () => {
      // check date validation
      dismissAllToasts();
      const referenceDate = new Date("1900-01-01");
      if (taskPaneState?.receivedDate) {
        const dateToCheck = new Date(taskPaneState?.receivedDate);

        if (dateToCheck < referenceDate) {
          notify("error", "Received Date must be on or after 01/01/1900");
          return
        }
      }
      if (taskPaneState.taskStartDate) {
        const dateToCheck = new Date(taskPaneState?.taskStartDate);

        if (dateToCheck < referenceDate) {
          notify("error", "Start Date must be on or after 01/01/1900");
          return
        }
      }
      if (taskPaneState.taskDueDate) {
        const dateToCheck = new Date(taskPaneState?.taskDueDate);

        if (dateToCheck < referenceDate) {
          notify("error", "Due Date must be on or after 01/01/1900");
          return
        }
      }

        setLoading(true);
    callParentIndex();
  }

  const callParentIndex = async () => {
    appInsights.trackEvent({ name: 'ButtonClicked', properties: { buttonName: 'SaveIndex', userID: taskPaneState?.userId } });
   try {
     let SubmissionDetails = {
            SubmissionID: null,
            PolicyID: selectedItemDetailFromGrid?.policyID,
            DocType: taskPaneState?.docDescription?.length? taskPaneState?.docDescription.substring(0, 60):"",
            DocumentClassID: +taskPaneState.documentClass,
            WorkflowUserID: +taskPaneState?.userGroup,
            Destination: "",
            DestName: "",
            PipsProducer: {
              ProducerID: selectedItemDetailFromGrid?.ProducerID,
              IndexingUserID: taskPaneState?.userId
            },
            FileURL: null,
            Container: null,
            ExtractAttachments: false,
            OriginatingOfficeID: "1",

            Sender: null,
            Recipient: null,
            CC: "",
            EmailHTML: null,
            FileContents: ""
          }
           const bodyData = {
                    subject: taskPaneState.taskSubject,
                    DocTypeId: taskPaneState?.documentType,
                    emailTime: "",
                    docTypeUsage: taskPaneState?.criteria === "Insured" || taskPaneState?.criteria === "Policy #"|| taskPaneState?.criteria  === "Submission #"? 1: 4,
                    description: taskPaneState?.docDescription?.length? taskPaneState?.docDescription.substring(0, 60):"",
                    dueDate: taskPaneState?.taskDueDate? new Date(taskPaneState?.taskDueDate): null,
                    pendDate: taskPaneState?.taskStartDate? new Date(taskPaneState?.taskStartDate): null,
                    modUserID: taskPaneState?.userId,
                    policyID: selectedItemDetailFromGrid?.policyID,
                    claimIncidentMasterID: 0,
                    providerID: 0,
                    producerID: 0,
                    destination: "",
                    destName: "",
                    workFlowUserID: +taskPaneState?.userGroup,
                    documentClassID: +taskPaneState?.documentClass,
                    compLocID: +taskPaneState?.comLocId,
                    indexNote: taskPaneState?.docNotes,
                    documentNote: taskPaneState?.docNotes,
                    note: taskPaneState?.taskNote,
                    task: taskPaneState?.taskChecked,
                    receivedDate: taskPaneState?.receivedDate? new Date(taskPaneState?.receivedDate) : null,
                    priorityID: +taskPaneState?.taskPriority,
                    taskTypeID: +taskPaneState?.taskType,
                    userGroupID: +taskPaneState?.userGroupId,
                    vendorID: 0,
                    campaignID: 0,
                    transSummaryID: 0,
                    docType: taskPaneState?.documentType,
                    policyChecklistID: +taskPaneState?.checklistItem,
                    chkTask: !!taskPaneState?.taskChecked,
                    chkUseFileName: !!taskPaneState?.useFileName,
                    chkQuoteSentToProducer: !!taskPaneState?.chkQuoteSentToProducer,
                    intFileID: 0,
                    userID: taskPaneState?.userId,
                    queueID: +taskPaneState?.taskQueue,
                    fileID: 0,
                    workFlowUser: "",
                    workFlowDestination: "",
                    submissionDetails: {
                      ...SubmissionDetails
                    }
                  };
          Office.context.ui.messageParent(JSON.stringify({ sendIndexApi: true, ...bodyData }));
          appInsights.trackDependencyData({
            target: process.env.BASE_URL,
            name: "Word_Saveindex_Payload",
            properties: { ...bodyData },
          });
   } catch (e) {
    setLoading(false);
    console.log(e);
   }
  }

  useEffect(() => {
  Office.onReady().then(() => {
                console.log("Dialog sending 'ready' to parent...");
                Office.context.ui.messageParent("ready");

                Office.context.ui.addHandlerAsync(
                    Office.EventType.DialogParentMessageReceived,
                    (arg) => {
                        console.log("Response received in dialog:", arg.message);
                        if(arg.message === "Failed") {
                          setLoading(false);
                          notify("error", "Failed to index");
                          
                          appInsights.trackDependencyData({
                            target: process.env.BASE_URL,
                            name: "Word_Saveindex_Payload",
                            dependencyTypeName: "HTTPS",
                            success: false,
                            responseCode: 500,
                            properties: {
                              error: "Failed to index"
                            }
                          });
                        } else if(arg.message === "ok") {
                          // setLoading(false);
                          notify("success", "Indexing successful!");
                          handleModel();
                        }
                        
                      const mes = JSON.parse(arg.message);
                      if (!!mes?.Failed && mes?.errorText) {
                        notify("error", mes?.errorText);
                        setLoading(false);

                        appInsights.trackDependencyData({
                          target: process.env.BASE_URL,
                          name: "Word_Saveindex_Payload",
                          dependencyTypeName: "HTTPS",
                          success: false,
                          responseCode: (mes?.errorText == "File is larger than allowed size") ? 400 : 500,
                          properties: {
                            error: mes?.errorText
                          }
                        });
                      }
                    }
                );
            });
  }, []);

    const handleModel = () => {
    Office.context.ui.messageParent(JSON.stringify({ close: true }));
  }

  const styles = useStyles();

  const clearToaster = () => {
    dismissAllToasts();
    notify("progress");
  }

  useEffect(() => {
    dismissAllToasts();
  }, [selectedGridItem])

  Office.onReady(() => {
    appInsights.trackPageView({ name: "Taskpane Loaded" });
  });

  return (
      <div className={styles.root}>
               {loading && <Loader />}
          <div className="page-bg">
              <div className="page-layout relative w-full mx-auto text-black z-10">
                 {/* <nav className="header-bg text-white px-4 py-1 shadow-md flex justify-between items-center fixed top-0 left-0 w-full  z-10" >
            <div className="w-full mx-auto px-0 flex justify-between items-center">
              <h1 className="text-sm font-semibold">PIPS</h1>
              <span className="text-sm">V4.0</span>
            </div>
          </nav> */}
          {Toaster}
          <div className="main-container p-1 mt-1">
                  <div className="card-layout p-2 shadow-md">
         
          <SearchCriteria
            updateState={updateState}
            clearToaster={clearToaster}
          />
          <RecentList
            updateState={updateState}
          />
          </div>
          <IndexingForm updateState={updateState} handleIndex={handleIndex} handleModel={handleModel} />
        </div>
        </div>
      </div>
    </div>
  );
};

export default MainContent;
